var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroups01 = function SvgGroups01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "groups-01_svg2__a",
    x1: 53.41,
    x2: 204.85,
    y1: 201.55,
    y2: 50.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#groups-01_svg2__a",
    id: "groups-01_svg2__b",
    x1: 57.04,
    x2: 208.48,
    y1: 205.18,
    y2: 53.74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#groups-01_svg2__a",
    id: "groups-01_svg2__c",
    x1: -5.41,
    x2: 146.03,
    y1: 142.74,
    y2: -8.7
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#groups-01_svg2__a",
    id: "groups-01_svg2__d",
    x1: -8.44,
    x2: 143,
    y1: 139.7,
    y2: -11.73
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M116.38 138.11c8.77-5.48 14.61-15.21 14.62-26.3 0-17.12-13.88-31.01-31.01-31.01s-31.01 13.88-31.01 31.01c0 11.1 5.84 20.83 14.6 26.31-16.49 6.53-28.15 22.62-28.15 41.44v16.26a3.91 3.91 0 0 0 3.91 3.91h81.3a3.91 3.91 0 0 0 3.91-3.91v-16.26c0-18.82-11.67-34.92-28.17-41.44Zm-39.57-26.3C76.81 99 87.19 88.62 100 88.62c12.8.01 23.18 10.39 23.19 23.19 0 12.8-10.37 23.18-23.17 23.19h-.04c-12.8 0-23.17-10.39-23.17-23.19m59.92 80.1H63.26v-12.35c0-20.29 16.45-36.74 36.74-36.74s36.74 16.45 36.75 36.74v12.35Z",
    style: {
      fill: "url(#groups-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.25 109.5a44.37 44.37 0 0 0-22.45-19.57c8.78-5.48 14.62-15.21 14.64-26.31 0-17.12-13.88-31.01-31.01-31.01s-31.01 13.88-31 31.01c0 11.1 5.84 20.83 14.61 26.31-1.86.74-3.7 1.61-5.49 2.62a3.905 3.905 0 0 0-1.47 5.3c1.05 1.88 3.43 2.55 5.32 1.5a36.7 36.7 0 0 1 18.02-4.73c20.3 0 36.76 16.44 36.77 36.74v12.35H142.8a3.91 3.91 0 1 0 0 7.82h53.29a3.91 3.91 0 0 0 3.91-3.91v-16.26c0-7.66-1.98-15.19-5.74-21.86zm-62.01-45.88c0-12.81 10.38-23.19 23.19-23.19 12.8.02 23.18 10.39 23.19 23.19 0 12.73-10.26 23.06-22.96 23.19h-.41c-12.73-.1-23.01-10.44-23.01-23.19",
    style: {
      fill: "url(#groups-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1 147.63a3.91 3.91 0 0 0-3.91-3.91H7.81v-12.35c0-6.31 1.63-12.52 4.73-18.02 6.71-11.92 19.08-18.65 31.84-18.73h.3c6.08.01 12.24 1.54 17.91 4.73 1.88 1.06 4.26.4 5.32-1.48s.4-4.26-1.48-5.32c-1.78-1-3.62-1.88-5.51-2.62 8.77-5.48 14.62-15.21 14.63-26.31 0-17.12-13.88-31.01-31.01-31.01S13.53 46.49 13.53 63.62c0 11.1 5.84 20.83 14.61 26.31C11.67 96.46 0 112.55 0 131.37v16.26a3.91 3.91 0 0 0 3.91 3.91H57.2a3.91 3.91 0 0 0 3.91-3.91zM21.36 63.62c0-12.81 10.38-23.19 23.19-23.19 12.8 0 23.18 10.39 23.19 23.19 0 12.81-10.38 23.19-23.19 23.19S21.36 76.43 21.36 63.62",
    style: {
      fill: "url(#groups-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.99 62.29c17.12-.02 30.99-13.89 31.01-31.01C131 14.16 117.12.27 99.99.27S68.98 14.15 68.98 31.28s13.88 31.01 31.01 31.01m0-54.2c12.8 0 23.18 10.39 23.19 23.19 0 12.81-10.38 23.19-23.19 23.19S76.8 44.09 76.8 31.28 87.18 8.09 99.99 8.09",
    style: {
      fill: "url(#groups-01_svg2__d)"
    }
  }));
};
export default SvgGroups01;